import React, { useState } from 'react';
import './ZonaDeSubida.css';

const UploadZone = ({ onSubir, loading }) => {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isDragging) setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const droppedFiles = e.dataTransfer.files;
    if (droppedFiles && droppedFiles.length > 0) {
      onSubir(droppedFiles); 
    }
  };

  const zoneClass = [
    'upload-zone-component',
    isDragging ? 'dragging' : '',
    loading ? 'loading' : ''
  ].filter(Boolean).join(' ');

  return (
    <div 
      className={zoneClass}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      <input 
        type="file" 
        id="file-upload" 
        className="upload-zone-input"
        onChange={onSubir}
        disabled={loading}
      />
      <label htmlFor="file-upload" className="upload-zone-label">
        <span className="upload-zone-icon">
          {loading 
            ? <i className="bi bi-hourglass-split"></i>
            : isDragging 
              ? <i className="bi bi-inbox"></i>
              : <i className="bi bi-cloud-upload"></i>
          }
        </span>
        <p className="upload-zone-text">
          {loading 
            ? "Subiendo a la nube de Administracion..." 
            : isDragging 
              ? "Soltalo ahora!" 
              : "Haz clic o arrastra archivos para subir"}
        </p>
      </label>
    </div>
  );
};

export default UploadZone;
